import { Link } from "react-router-dom";
import { ArrowUpRight, Clock, Mail, MapPin, Phone } from "lucide-react";
import { Reveal, SplitLines } from "@/components/ui-custom/Reveal";
import { COMPANY } from "@/lib/api";

const ITEMS = [
  { icon: MapPin, label: "Warehouse & slice house", value: COMPANY.address, href: `https://maps.google.com/?q=${encodeURIComponent(COMPANY.address)}`, id: "address" },
  { icon: Phone, label: "Phone", value: COMPANY.phone, href: COMPANY.phoneHref, id: "phone" },
  { icon: Mail, label: "Email", value: COMPANY.email, href: `mailto:${COMPANY.email}`, id: "email" },
  { icon: Clock, label: "Trading hours", value: COMPANY.hours, id: "hours" },
];

export default function Contact() {
  return (
    <main className="pt-[72px]" data-testid="contact-page">
      <section className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 pt-16 lg:pt-24 pb-24 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-6">
          <p className="eyebrow text-[var(--terracotta)] mb-6">Contact</p>
          <SplitLines lines={["Talk to the", "Deliver team."]} delay={0.1} className="font-display font-normal text-4xl sm:text-5xl lg:text-7xl leading-[1] text-[var(--ink)]" data-testid="contact-title" />
          <Reveal delay={0.4}><p className="mt-6 text-base md:text-lg font-light text-[var(--charcoal)] leading-relaxed max-w-lg">Orders, range questions, slice house enquiries or new accounts, we're in the warehouse from 6am weekdays and happy to help.</p></Reveal>
          <div className="mt-12 divide-y divide-[var(--sand)] border-y border-[var(--sand)]">
            {ITEMS.map((it, i) => (
              <Reveal key={it.id} delay={0.45 + i * 0.08} className="py-6 flex items-start gap-5" data-testid={`contact-${it.id}`}>
                <span className="h-10 w-10 rounded-full bg-[var(--cream-2)] grid place-items-center text-[var(--terracotta)] shrink-0"><it.icon size={16} /></span>
                <div>
                  <p className="eyebrow !text-[0.6rem] text-[var(--muted)]">{it.label}</p>
                  {it.href ? <a href={it.href} target={it.href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" className="font-display text-xl lg:text-2xl text-[var(--ink)] link-underline mt-1 inline-block">{it.value}</a> : <p className="font-display text-xl lg:text-2xl text-[var(--ink)] mt-1">{it.value}</p>}
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.8} className="mt-10 flex flex-wrap gap-3">
            <Link to="/become-a-stockist" className="btn-pill btn-ink" data-testid="contact-stockist-cta">Become a stockist <ArrowUpRight size={14} /></Link>
            <p className="self-center text-xs text-[var(--muted)]">ABN {COMPANY.abn}</p>
          </Reveal>
        </div>
        <Reveal delay={0.3} className="lg:col-span-6">
          <div className="img-frame aspect-[4/5] lg:aspect-auto lg:h-full min-h-[420px] rounded-sm">
            <iframe title="Deliver Mount Druitt" src={`https://maps.google.com/maps?q=${encodeURIComponent(COMPANY.address)}&z=14&output=embed`} className="absolute inset-0 w-full h-full grayscale-[0.4] contrast-[1.05]" loading="lazy" data-testid="contact-map" />
          </div>
        </Reveal>
      </section>
    </main>
  );
}
